export function NotFound() {
  return (
    <div class="text-4xl text-gray-500 text-center py-8 w-full grow">
      404 | That message could not be found.
    </div>
  );
}
